import { render, staticRenderFns } from "./TpsItems.vue?vue&type=template&id=32de5e22&scoped=true&"
import script from "./TpsItems.vue?vue&type=script&lang=js&"
export * from "./TpsItems.vue?vue&type=script&lang=js&"
import style0 from "./TpsItems.vue?vue&type=style&index=0&id=32de5e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de5e22",
  null
  
)

export default component.exports